import React from 'react';

export default function ShimmerCard({
  children,
  className = '',
}: {
  children: React.ReactNode;
  className?: string;
}) {
  const customCss = `
    @property --angle {
      syntax: '<angle>';
      initial-value: 0deg;
      inherits: false;
    }
    @keyframes shimmer-spin {
      to {
        --angle: 360deg;
      }
    }
  `;
  return (
    <div
      className={`relative p-[2.5px] rounded-2xl overflow-hidden group ${className}`}
    >
      <style>{customCss}</style>
      <div
        className="absolute inset-0 pointer-events-none rounded-2xl"
        style={{
          background:
            'conic-gradient(from var(--angle), transparent 25%, #f59542, transparent 70%)',
          animation: 'shimmer-spin 2.5s linear infinite',
        }}
      />
      <div className="relative z-10 size-full rounded-2xl bg-white dark:bg-neutral-90">
        {children}
      </div>
    </div>
  );
}
